export default () => {
	const langBlock = document.querySelectorAll('.js-lang');
	// const topbar = document.querySelector('.js-topbar');
	const form = document.getElementById('localization_form');
	const input = document.querySelector('input[name="language_code"], input[name="country_code"]');

	if(langBlock.length){
		langBlock.forEach(lang => {
			let langBtn = lang.querySelector('.js-lang-btn');

			langBtn.addEventListener('click', () => {
				if(!lang.classList.contains('is-opened')){
					// topbar.style.overflow = 'visible'
					lang.classList.add('is-opened');
				} else {
					lang.classList.remove('is-opened');
					// topbar.style.overflow = 'hidden'
				}
			});
		});

		document.addEventListener('click', (e) => {
			let target = e.target;

			langBlock.forEach(lang => {
				let langBtn = lang.querySelector('.js-lang-btn');
				let langList = lang.querySelector('.js-lang-list');

				let langBtnTarget = target == langBtn || langBtn.contains(target);
				let langListTarget = target == langList || langList.contains(target);
				let isOpened = lang.classList.contains('is-opened');

				if((!langBtnTarget && !langListTarget) && isOpened){
					// topbar.style.overflow = 'hidden';
					lang.classList.remove('is-opened');
				}
			});
		});


		// if(topbar){
		// 	let bgColor = window.getComputedStyle(topbar).getPropertyValue('background-color');
		// 	const whiteColor = 'rgb(255, 255, 255)';

		// 	if(bgColor == whiteColor){
		// 		topbar.classList.add('white-bg');
		// 	}
		// }

		const chooseLang = document.querySelectorAll('.js-choose-lang');

		chooseLang.forEach(item => {
			item.addEventListener('click', (e) => {
				e.preventDefault();

				const nextLang = item;
				input.value = item.dataset.value;

				if(item.classList.contains('active')){
					
				} else {
					chooseLang.forEach(item => {
						item.classList.remove('active');
					});

					nextLang.classList.add('active');

					langBlock.forEach(lang => {
						lang.classList.remove('is-opened');
					});
				}

				if (form) form.submit();
			});
		});
	}
}